import clsx from 'clsx';
import Txt from 'components/atoms/Txt/Txt';
import { LocaleInfo } from './getLocaleInfo';
import classes from './LanguageListItem.module.scss';
import { MdOutlineCheck } from 'react-icons/md';
import LanguagePickGlobe from 'components/assets/LanguagePickGLobe.svg';

export type Props = {
  localeInfo: LocaleInfo;
  checked: boolean;
  className?: string;
  languageClassName?: string;
  isDropdownToggle?: boolean;
  onLanguagePick?: (locale: string | undefined) => void;
};

export default function LanguageListItem({
  localeInfo,
  checked,
  className,
  languageClassName,
  isDropdownToggle,
  onLanguagePick,
}: Props): JSX.Element {
  return (
    <Txt
      className={clsx(classes.root, isDropdownToggle && classes.isDropdownToggle, className)}
      onClick={() => onLanguagePick && onLanguagePick(localeInfo?.locale)}
      skipTranslation
    >
      <div className={classes.check}>
        {checked ? (
          <>
            <MdOutlineCheck />
          </>
        ) : isDropdownToggle ? (
          <LanguagePickGlobe width={34} height={34} className={classes.globe} />
        ) : null}
      </div>
      <div className={classes.label}>
        <Txt className={clsx(classes.language, languageClassName)} skipTranslation>
          {localeInfo.language?.native || localeInfo.locale}
        </Txt>
        <Txt className={classes.country} skipTranslation>
          {localeInfo.country?.native}
        </Txt>
      </div>
    </Txt>
  );
}
